import React, { useState, useEffect } from 'react';
import './App.css';
import Cookies from 'js-cookie';
import EasySpeech from 'easy-speech'
import { isAndroid, isIOS } from "react-device-detect";
import LoadingScreen from './components/loadingScreen/LoadingScreen'
import Policy from './components/policy/Policy';
import Zodiac from './components/zodiac/Zodiac';
import Color from './components/color/Color';
import Result from './components/result/Result';
import Chat from './components/chat/Chat';

import logo from './assets/logo.png'
import nebula from './assets/nebula.jpg'

import countVisitors from './hooks/countVisitors';

EasySpeech.init()

function App() {
  const [assetsLoading, setAssetsLoading] = useState({ nebula: true, logo: true, aries: true, taurus: true, gemini: true, cancer: true, leo: true, virgo: true, libra: true, scorpio: true, sagittarius: true, capricorn: true, aquarius: true, pisces: true, red: true, maroon: true, yellow: true, orange: true, lightGreen: true, green: true, aqua: true, skyBlue: true, blue: true, purple: true, white: true, black: true })
  const [windowSize, setWindowSize] = useState({ height: window.innerHeight, width: window.innerWidth })
  const [details, setDetails] = useState({ zodiac: '', color: '' })
  const [ads, setAds] = useState({ image: '', url: '' })
  const [result, setResult] = useState('')
  const [loading, setLoading] = useState(false)
  const [backEvents, setBackEvents] = useState(true)
  const [zodiacState, setZodiacState] = useState({ display: true, animation: true, events: true })
  const [colorState, setColorState] = useState({ display: false, animation: false, events: false })
  const [resultState, setResultState] = useState({ display: false, animation: false, events: false, video: false })
  const [seeMoreState, setSeeMoreState] = useState({ display: false, animation: false })
  const [chatState, setChatState] = useState({ display: false, animation: false, events: false })
  const [policyState, setPolicyState] = useState({ display: false, animation: false })
  const [emailDetails, setEmailDetails] = useState({ email: '', loading: false, display: false, animation: false })

  useEffect(() => {
    countVisitors({ page: 'spanish2-zodiac' })
    
    function handleWindowResize() { setWindowSize({height: window.innerHeight, width: window.innerWidth}) }
    function handleFocus(e) { e.preventDefault(); EasySpeech.resume(); }
    function handleBlur(e) { e.preventDefault(); EasySpeech.pause(); }
    
    window.addEventListener('resize', handleWindowResize);
    window.addEventListener("focus", (e) => handleFocus(e))
    window.addEventListener("blur", (e) => handleBlur(e))
    
    return () => {
      window.removeEventListener('resize', handleWindowResize);
      window.addEventListener("focus", (e) => handleFocus(e))
      window.addEventListener("blur", (e) => handleBlur(e))
    };
  }, [])
  
  useEffect(() => {
    EasySpeech.init()
    EasySpeech.detect()

    if (result !== '') {
      let splits = result.split(' ')
      let tempSplits = []
      let tempArray = []
      let tempCount = 0

      for (let i = 0; i < splits.length; i++) {
        if (tempCount >= 20) {
          tempSplits.push(splits[i])
          tempArray.push(tempSplits.join(' '))
          tempSplits = []
          tempCount = 0
        } else {
          tempSplits.push(splits[i])
          tempCount = tempCount + 1
        }
        if (i === splits.length - 1) {
          tempArray.push(tempSplits.join(' '))
          tempSplits = []
          tempCount = 0
        }
      } 

      for (let i = 0; i < tempArray.length; i++) {
        if (isIOS) {
          EasySpeech.speak({
            text: tempArray[i],
            voice: EasySpeech.voices()[EasySpeech.voices().findIndex((e) => {return e.lang === 'es-ES'})],
            boundary: event => console.debug('word boundary reached', event.charIndex),
            error: e => console.log(e),
          })
        } else if (isAndroid) {
          EasySpeech.speak({
            text: tempArray[i],
            voice: EasySpeech.voices()[EasySpeech.voices().findIndex((e) => {return e.lang === 'es_ES'})],
            boundary: event => console.debug('word boundary reached', event.charIndex),
            error: e => console.log(e),
          })
        } else {
          EasySpeech.speak({
            text: tempArray[i],
            voice: EasySpeech.voices()[EasySpeech.voices().findIndex((e) => {return e.lang === 'es-ES'})],
            boundary: event => console.debug('word boundary reached', event.charIndex),
            error: e => console.log(e),
          })
        }
      }
    }
  }, [result])

  // const handleGenie = () => {
  //   if (Cookies.get('horoscopeEmail')) {
  //     setZodiacState(e => {return {...e, animation: false, events: false}})
  //     setColorState(e => {return {...e, animation: false, events: false}})
  //     setResultState(e => {return {...e, animation: false, events: false}})
  //     setSeeMoreState(e => {return {...e, animation: false}})
  //     setChatState(e => {return {...e, display: true}})
  //     EasySpeech.cancel()
      
  //     setTimeout(() => {
  //       setDetails({ zodiac: '', color: '' })
  //       setResult('')
  //       setZodiacState(e => {return {...e, display: false}})
  //       setColorState(e => {return {...e, display: false}})
  //       setResultState(e => {return {...e, display: false}})
  //       setSeeMoreState(e => {return {...e, display: false}})
  //       setChatState(e => {return {...e, animation: true, events: true}})
  //     }, 1000);
  //   }
  //   else {
  //     window.alert("You can not view this page unless you send your email!")
  //   }
  // }

  const handlePolicyOpen = () => {
    countVisitors({ page: 'spanish2-policy' })

    setPolicyState(e => {return {...e, display: true}})
    
    setTimeout(() => {
      setPolicyState(e => {return {...e, animation: true}})
    }, 100);
  }

  const handlePolicyClose = () => {
    setPolicyState(e => {return {...e, animation: false}})
    
    setTimeout(() => {
      setPolicyState(e => {return {...e, display: false}})
    }, 1000);
  }

  const handleBack = () => {
    setZodiacState(e => {return {...e, display: true}})
    setColorState(e => {return {...e, animation: false, events: false}})
    setResultState(e => {return {...e, animation: false, events: false}})
    setSeeMoreState(e => {return {...e, animation: false}})
    setChatState(e => {return {...e, animation: false, events: false}})
    setEmailDetails(e => {return {...e, animation: false}})
    EasySpeech.cancel()
    
    setTimeout(() => {
      setDetails({ zodiac: '', color: '' })
      setResult('')
      setZodiacState(e => {return {...e, animation: true, events: true}})
      setColorState(e => {return {...e, display: false}})
      setResultState(e => {return {...e, display: false}})
      setSeeMoreState(e => {return {...e, display: false}})
      setChatState(e => {return {...e, display: false}})
      setEmailDetails(e => {return {...e, display: false, email: ''}})
    }, 1000);
  }

  return (
    <div className='app'>
      <LoadingScreen assetsLoading={assetsLoading} />
      <Policy policyState={policyState} handlePolicyClose={handlePolicyClose} />
      <img src={nebula} alt='nebula' onLoad={() => {setAssetsLoading(prev => {return {...prev, nebula: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, nebula: false}})}}/>
      <div className='appContainer'>
        <div className='appLogo' style={{ pointerEvents: (backEvents) ? 'all' : 'none' }} onClick={() => handleBack()}>
          <img src={logo} alt="logo" onLoad={() => {setAssetsLoading(prev => {return {...prev, logo: false}})}} onError={() => {setAssetsLoading(prev => {return {...prev, logo: false}})}}/>
          <div>Horoscopo</div>
        </div>
        
        {/* <div className='appBack' style={{ opacity: (Cookies.get('horoscopeEmail')) ? 1 : 0, pointerEvents: (Cookies.get('horoscopeEmail')) ? (backEvents) ? 'all' : 'none' : 'none', right: (homeState.display) ? '20px' : '70px' }} onClick={() => handleGenie()}>Genie</div> */}
        
        <div className='appBack' style={{ opacity: (zodiacState.display) ? 0 : 1, pointerEvents: (zodiacState.display || !backEvents) ? 'none' : 'all' }} onClick={() => handleBack()}>Volver</div>

        <div className='appPolicy' style={{pointerEvents: (!backEvents) ? 'none' : 'all' }} onClick={() => handlePolicyOpen()}>Politica De Privacidad</div>

        <Zodiac setAssetsLoading={setAssetsLoading} windowSize={windowSize} details={details} setDetails={setDetails} zodiacState={zodiacState} setZodiacState={setZodiacState} setColorState={setColorState}/>
        <Color setAssetsLoading={setAssetsLoading} windowSize={windowSize} setLoading={setLoading} setBackEvents={setBackEvents} setResult={setResult} details={details} setDetails={setDetails} colorState={colorState} setColorState={setColorState} setResultState={setResultState} setAds={setAds}/>
        <Result windowSize={windowSize} loading={loading} setLoading={setLoading} setBackEvents={setBackEvents} result={result} setResult={setResult} details={details} resultState={resultState} setResultState={setResultState} seeMoreState={seeMoreState} setSeeMoreState={setSeeMoreState} setChatState={setChatState}/>
        <Chat chatState={chatState} setBackEvents={setBackEvents} emailDetails={emailDetails} setEmailDetails={setEmailDetails} ads={ads}/>
      </div>
    </div>
  );
}

export default App;